import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';
import { ConfigService } from '@cue-admin/config';

@Directive({
  selector: 'div[appWIPHide], kendo-panelbar[appWIPHide], li[appWIPHide]',
  standalone: true,
})
export class WipDirective implements AfterViewInit {
  private readonly configService = inject(ConfigService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly appWIPHide = input<boolean | '' | undefined>(undefined);

  ngAfterViewInit(): void {
    if (this.appWIPHide() !== false) {
      const config = this.configService.value;
      const isWIP = config?.wip !== null && config?.wip !== undefined ? config.wip : config?.apiWip;
      if (!isWIP) {
        this.elementRef.nativeElement.style.setProperty('display', 'none', 'important');
      } else {
        this.elementRef.nativeElement.style.setProperty('background-color', '#e5e5f7', 'important');
        this.elementRef.nativeElement.style.setProperty(
          'background-image',
          'repeating-linear-gradient(45deg, rgba(247, 69, 69, 0.1) 25%, transparent 25%, transparent 75%, rgba(247, 69, 69, 0.1) 75%, rgba(247, 69, 69, 0.23)), repeating-linear-gradient(45deg, rgba(247, 69, 69, 0.1) 25%, #e5e5f7 25%, #e5e5f7 75%, rgba(247, 69, 69, 0.1) 75%, rgba(247, 69, 69, 0.1))',
          'important'
        );
        this.elementRef.nativeElement.style.setProperty('background-position', '0 0, 17px 17px', 'important');
        this.elementRef.nativeElement.style.setProperty('background-size', '34px 34px', 'important');
      }
    }
  }
}
